var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumbs',{attrs:{"main":"","title":"Audit Log"}}),_c('div',{staticClass:"container-fluid"},[_c('AuditLogs',{attrs:{"entity_type":"All","vrm":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }